import React, { useEffect, useState } from "react";
import { PortalOverlayLoader } from "./PortalLoader";
import { subscribePortalLoading } from "../utils/portalLoading";

export default function PortalLoadingProvider({ children }) {
  const [pending, setPending] = useState(0);

  useEffect(() => subscribePortalLoading(setPending), []);

  return (
    <>
      {children}
      {pending > 0 ? <PortalOverlayLoader message="Please wait" submessage="Processing your request…" /> : null}
    </>
  );
}
